// Lib
import storage from 'redux-persist/lib/storage';
import { applyMiddleware, createStore } from 'redux';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

// Root saga
import mainSaga from '../sagas';

// Root reducer
import rootReducer from '../reducers';

// Migrations
import migrations from './migrations';

// Transforms
import { selectedOrganizationTransform } from './transforms';

const persistConfig = {
  key: 'root',
  storage,
  version: 1,
  whitelist: ['Account', 'SelectedOrganization', 'User', 'Slides'],
  blackList: ['redirectControl'],
  migrate: createMigrate(migrations, { debug: true }),
  // Keep short-lived signed avatar URLs out of persisted storage (#83) — they
  // expire and 403 if rehydrated stale; the boot re-sync refreshes them.
  transforms: [selectedOrganizationTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sagaMiddleware = createSagaMiddleware();

const configureStore = () =>
  createStore(
    persistedReducer,
    {},
    composeWithDevTools(applyMiddleware(sagaMiddleware)),
  );

const configuredStore = configureStore();
const persist = persistStore(configuredStore);

sagaMiddleware.run(mainSaga);

export { persist };
export default configuredStore;
